module.exports = __webpack_public_path__ + "img/iv_b2_pic3.3fbcf80c.png";